<template>
  <div class="video-dialog-wrapper">
    <van-dialog
      ref="video-dialog"
      class="video-dialog"
      v-if="isShowVideoDialog"
      :is-disable-close="true"
      :is-show-footer="false">
      <template slot="title">
        <van-quizzes-toolbar
          :title="titleText"
          :is-forced="false"
          @close="closeVideo" />
      </template>
      <div
        class="video-title"
        v-if="quizes.length >= 2">
        选择其中一个导学视频即可开始观看，结合导学视频，轻松掌握更多知识点</div>
      <div
        class="quiz-wrapper videos"
        v-if="quizes.length >= 2">
          <div class="left">
            <div class="video-wrapper"
              :class="{ active: index === activeIndex }"
              @click="toggle(index)"
              v-for="(quiz, index) in quizes" :key="index">
              <van-w-k
                class="preview-image"
                :key="index"
                ref="wk"
                :class="{ 'hide-control': quizes.length >= 2 }"
                :disable-play="true"
                :exercise="quiz"
                :is-repeat-watch="quiz.isRepeatWatch"
                :disable-space="true"
                :can-drag="quiz.videoDone"
                @ended="onVideoEnded"
                @complete="closeVideo">
              </van-w-k>
              <div class="video-name">{{quiz.name}}</div>
            </div>
          </div>
          <div class="right">
            <div
              class="w-k-wrapper">
              <div
                v-for="(quiz, index) in quizes"
                :key="index">
                  <van-w-k
                    class="w-k"
                    ref="wk"
                    v-if="index === activeIndex"
                    :class="{ 'hide-control': quizes.length >= 2 }"
                    :exercise="currentVideo"
                    :is-repeat-watch="quiz.isRepeatWatch"
                    :can-drag="quiz.videoDone"
                    @ended="onVideoEnded(quiz)"
                    @complete="closeVideo">
                  </van-w-k>
                </div>
            </div>
          </div>
      </div>
      <div
        class="quiz-wrapper"
        v-else>
        <van-w-k
          class="wk"
          :exercise="quizes[0]"
          :can-drag="quizes[0] ? quizes[0].videoDone : 0"
          :is-repeat-watch="quizes[0] ? quizes[0].isRepeatWatch : false"
          @ended="onVideoEnded(quizes[0])"
          @complete="closeVideo">
        </van-w-k>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import 'vanthink-components/icon/iconfont.css';
import VanDialog from '@/components/common/Dialog.vue';
import VanQuizzesToolbar from '@/components/quizzes/QuizzesToolbar.vue';
import VanWK from 'vanthink-components/components/quiz/WK.vue';
import api from '@/api/graphql/learning';
import utils from '@/services/utils';

export default {
  components: {
    VanDialog,
    VanQuizzesToolbar,
    VanWK,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    titleText() {
      if (this.payload.name && this.payload.action === 'section') {
        return `${this.payload.name}-导学视频`;
      }
      return this.title;
    },
    currentVideo() {
      return this.quizes[this.activeIndex];
    },
  },
  data() {
    return {
      quizes: [],
      type: null,
      activeIndex: 0,
      payload: {},
      isShowVideoDialog: false,
    };
  },
  methods: {
    playVideo(id, type = 'active', payload) {
      this.isShowVideoDialog = true;
      this.type = type;
      if (payload.action === 'section') {
        this.payload = payload;
        this.quizes = payload.video.map(item => ({
          code: 'Wk',
          name: item.name,
          video: item.video,
          poster: item.poster,
          quizzes: item.quizzes,
          isRepeatWatch: payload.isCompleted,
          videoDone: item.videoDone,
        }));
        this.$nextTick(() => {
          this.$refs['video-dialog'].open();
        });
      } else {
        api.learningVideo({
          chapterId: id,
        })
          .then(({ learningVideo }) => {
            this.payload.action = 'chapter';
            if (type === 'active') {
              this.quizes = [{
                code: 'WK',
                video: learningVideo.video,
                poster: learningVideo.poster,
                quizzes: learningVideo.quizzes,
                videoDone: learningVideo.videoDone,
                isRepeatWatch: !!payload.isCompleted,
              }];
              this.$refs['video-dialog'].open();
            } else if (learningVideo.isPush) {
              this.quizes = [{
                code: 'WK',
                video: learningVideo.video,
                poster: learningVideo.poster,
                quizzes: learningVideo.quizzes,
                videoDone: learningVideo.videoDone,
                isRepeatWatch: !!payload.isCompleted,
              }];
              this.payload = payload;
              this.$refs['video-dialog'].open();
            } else {
              this.$emit('continue', payload);
            }
          })
          .catch((error) => {
            if (error && error.code === 1033) {
              utils.alert(`<div style="white-space: pre-line;">${error.message}</div>`, '体验结束', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '知道了',
                center: true,
              });
            } else {
              utils.error(error.message);
            }
          });
      }
    },
    onVideoEnded(video) {
      /* 小节没有知识点 观看完导学视频需调用反馈接口继续学习 */
      utils.post('/api/home/assessment/basic/saveVideoPlay', {
        data: {
          url: video.video,
        },
      })
        .then();
      if (this.payload.action === 'chapter') return;
      if (!this.payload.isHasKnowledge || !this.payload.isActive) {
        utils.post('/api/home/assessment/update/videoFeedback', {
          data: {
            catalog_id: this.payload.id,
          },
        })
          .then(() => {
            this.$emit('complete-knowledge');
          });
      }
      this.payload.video[this.activeIndex].videoDone = 1;
    },
    closeVideo() {
      this.isShowVideoDialog = false;
      this.$refs['video-dialog'].close();
      if (this.type !== 'active' && this.type !== 'section') {
        this.$emit('continue', this.payload);
      }
    },
    toggle(index) {
      this.activeIndex = index;
      // const videos = document.querySelectorAll('video');
      // videos.forEach((video, key) => {
      //   if (index !== key) {
      //     video.pause();
      //   }
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

  .video-dialog-wrapper {
    .video-dialog {
      /deep/ .el-dialog__body {
        .content {
          padding: 0;
        }
      }
      .quiz-wrapper {
        margin-top: 10px;
        height: 510px;
      }
      .video-title {
        margin: 10px 0 0 10px;
      }
      .videos {
        display: flex;
        .left {
          margin-bottom: 10px;
          width: 210px;
          overflow-y: auto;
          border-right: 1px solid $border-color;
          .video-wrapper {
            margin: 0 0 10px;
            padding: 10px 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            cursor: pointer;
            /deep/ .preview-image {
              width: 180px;
              height: 100px;
              video {
                object-fit: fill;
                width: 180px;
                height: 100px;
              }
              .control {
                display: none;
              }
              .play {
                display: none;
              }
            }
            .video-name {
              margin-top: 10px;
              width: 180px;
              text-align: center;
            }
          }
          .active {
            color: $primary;
            background-color: #f3f3f3;
          }
        }
        .right {
          display: flex;
          justify-content: center;
          box-sizing: border-box;
          width: calc(100% - 211px);
          margin: 0 19px;
          overflow-y: auto;
          /deep/ .w-k-wrapper {
            width: 100%;
            margin: auto 0;
            .w-k {
              height: auto;
            }
          }
        }
        /deep/ .hide-control {
          .control-bar {
            display: none;
          }
        }
      }
    }
  }
</style>
